'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _adverseEventSearch = require('./adverse-event-search.html');

var _adverseEventSearch2 = _interopRequireDefault(_adverseEventSearch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _adverseEventSearch2.default,
  bindings: {
    animalTypes: '<',
    eventTypes: '<',
    searchTypes: '<',
    searchCriteria: '<',
    onSearchCriteriaChanged: '&',
    onSearchTextChanged: '&',
    onSearchByTextChanged: '&'
  },
  controller: function () {
    function AdverseEventSearchComponent(EventEmitter, ProductService) {
      'ngInject';

      _classCallCheck(this, AdverseEventSearchComponent);

      Object.assign(this, { EventEmitter: EventEmitter, ProductService: ProductService });
    }

    _createClass(AdverseEventSearchComponent, [{
      key: '$onChanges',
      value: function $onChanges(changes) {
        if (changes.searchCriteria) {
          this.searchCriteria = Object.assign({}, this.searchCriteria);
        }
      }
    }, {
      key: 'onChange',
      value: function onChange() {
        this.onSearchCriteriaChanged(this.EventEmitter({
          searchCriteria: this.searchCriteria
        }));
      }
    }, {
      key: 'onSearchTextChange',
      value: function onSearchTextChange(text) {
        this.onSearchTextChanged(this.EventEmitter({
          searchText: text
        }));
      }
    }, {
      key: 'onSearchByTextChange',
      value: function onSearchByTextChange(text) {
        this.onSearchByTextChanged(this.EventEmitter({
          searchByText: text
        }));
      }
    }, {
      key: 'selectedIngredientChanged',
      value: function selectedIngredientChanged($event) {
        this.searchCriteria.selectedIngredient = $event.selectedIngredient;
        this.onChange();
      }
    }, {
      key: 'searchProducts',
      value: function searchProducts(name) {
        return this.ProductService.searchProductsByName(name).then(function (r) {
          return r.data;
        });
      }
    }, {
      key: 'selectedMemberChanged',
      value: function selectedMemberChanged($event) {
        this.searchCriteria.selectedCompany = $event.company;
        this.onChange();
      }
    }]);

    return AdverseEventSearchComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/adverse-events/adverse-event-search/adverse-event-search.component.js